import { c as _c } from "react/compiler-runtime";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { MouseEvent } from "react";
import { useMemo } from "react";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import { getContributorLabel, type RepDirection } from "./UserPageRep.helpers";
const stopPropagation = (e: MouseEvent) => e.stopPropagation();
export default function RepCategoryPill(t0) {
  const $ = _c(44);
  const {
    category,
    canEdit,
    onEdit,
    compact: t1,
    direction: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const direction = t2 === undefined ? "received" : t2;
  const paddingClass = compact ? "tw-px-3 tw-py-2" : "tw-px-4 tw-h-11";
  const layoutClass = compact ? "tw-inline-flex tw-flex-wrap tw-items-center tw-gap-x-2.5 tw-gap-y-1.5" : "tw-inline-flex tw-items-center tw-gap-2.5";
  let t3;
  if ($[0] !== category.top_contributors) {
    t3 = category.top_contributors.map(_temp);
    $[0] = category.top_contributors;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const avatarItems = t3;
  let t4;
  if ($[2] !== category.category) {
    t4 = <span className="tw-whitespace-nowrap tw-text-left tw-text-sm tw-font-medium tw-text-white">{category.category}</span>;
    $[2] = category.category;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== category.total_rep) {
    t5 = formatNumberWithCommas(category.total_rep);
    $[4] = category.total_rep;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-colors group-hover:tw-text-iron-300">{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t4}{t6}</span>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `tw-text-xs tw-text-white/20 ${compact ? "tw-hidden sm:tw-inline" : ""}`;
  let t9;
  if ($[11] !== t8) {
    t9 = <span className={t8}>·</span>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== avatarItems) {
    t10 = avatarItems.length > 0 && <span role="presentation" className="tw-pointer-events-none desktop-hover:tw-pointer-events-auto" onClick={stopPropagation}><OverlappingAvatars items={avatarItems} size="sm" maxCount={5} onItemClick={_temp2} /></span>;
    $[13] = avatarItems;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== category.contributor_count) {
    t11 = formatNumberWithCommas(category.contributor_count);
    $[15] = category.contributor_count;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== category.contributor_count || $[18] !== direction) {
    t12 = getContributorLabel(direction, category.contributor_count);
    $[17] = category.contributor_count;
    $[18] = direction;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{t11}{" "}{t12}</span>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t13) {
    t14 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t10}{t13}</span>;
    $[23] = t10;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== category.authenticated_user_contribution || $[27] !== direction) {
    t15 = category.authenticated_user_contribution !== null && category.authenticated_user_contribution !== 0 && <><span className="tw-text-xs tw-text-white/20">·</span><span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{direction === "given" ? "Assigned To You:" : "You Assigned:"}{" "}<span className="tw-font-medium tw-text-primary-400">{category.authenticated_user_contribution > 0 && "+"}{formatNumberWithCommas(category.authenticated_user_contribution)}</span></span></>;
    $[26] = category.authenticated_user_contribution;
    $[27] = direction;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15 || $[31] !== t7 || $[32] !== t9) {
    t16 = <>{t7}{t9}{t14}{t15}</>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t7;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const content = t16;
  const baseClasses = `group ${layoutClass} tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-[#18191B] tw-transition-all tw-duration-300 tw-ease-out ${paddingClass}`;
  if (canEdit) {
    let t17;
    if ($[34] !== category.category || $[35] !== onEdit) {
      t17 = () => onEdit(category.category);
      $[34] = category.category;
      $[35] = onEdit;
      $[36] = t17;
    } else {
      t17 = $[36];
    }
    const t18 = `${baseClasses} tw-cursor-pointer hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-shadow-md`;
    let t19;
    if ($[37] !== content || $[38] !== t17 || $[39] !== t18) {
      t19 = <button type="button" onClick={t17} className={t18}>{content}</button>;
      $[37] = content;
      $[38] = t17;
      $[39] = t18;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    return t19;
  }
  const t17 = `${baseClasses} tw-cursor-default`;
  let t18;
  if ($[41] !== content || $[42] !== t17) {
    t18 = <div className={t17}>{content}</div>;
    $[41] = content;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp2(e) {
  return stopPropagation(e);
}
function _temp(c) {
  return {
    key: c.profile.handle ?? c.profile.primary_address,
    pfpUrl: c.profile.pfp ?? null,
    href: `/${c.profile.handle ?? c.profile.primary_address}`,
    ariaLabel: c.profile.handle ?? c.profile.primary_address,
    fallback: c.profile.handle ? c.profile.handle.charAt(0).toUpperCase() : "?",
    title: c.profile.handle ?? c.profile.primary_address,
    tooltipContent: <span>{c.profile.handle ?? c.profile.primary_address} ·{" "}{formatNumberWithCommas(c.contribution)}</span>
  };
}